import { render, staticRenderFns } from "./comTerm5.vue?vue&type=template&id=30621a8c&scoped=true&"
import script from "./comTerm5.vue?vue&type=script&lang=js&"
export * from "./comTerm5.vue?vue&type=script&lang=js&"
import style0 from "./comTerm5.vue?vue&type=style&index=0&id=30621a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30621a8c",
  null
  
)

export default component.exports